import {Component, OnDestroy, OnInit} from '@angular/core';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {UserApiService} from '@app/services/api/user-api.service';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';

@Component({
    selector: 'app-companion-qr-login-dialog',
    templateUrl: './companion-qr-login-dialog.component.html',
    styleUrls: ['./companion-qr-login-dialog.component.scss'],
    standalone: false
})
export class CompanionQrLoginDialogComponent implements OnInit, OnDestroy {
    public qrData: string | null = null;
    public isLoading = true;
    public errorMessage: string | null = null;
    public errorReason: 'account_setup_incomplete' | 'generation_failed' | null = null;
    public requiredActions: string[] = [];

    private destroy$ = new Subject<void>();

    constructor(
        public dialogRef: MatDialogRef<CompanionQrLoginDialogComponent>,
        private userApiService: UserApiService,
    ) {}

    static open(dialog: MatDialog) {
        return dialog.open(CompanionQrLoginDialogComponent, {
            width: '500px',
            disableClose: false,
        });
    }

    ngOnInit(): void {
        this.loadQrToken();
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    loadQrToken(): void {
        this.isLoading = true;
        this.errorMessage = null;
        this.errorReason = null;
        this.requiredActions = [];
        this.qrData = null;

        this.userApiService.getCompanionQrLoginToken()
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (response) => {
                    this.isLoading = false;
                    if (response.success && response.keycloak_refresh_token) {
                        this.qrData = `autobrief-companion://auth?refresh_token=${response.keycloak_refresh_token}`;
                    } else {
                        this.errorReason = response.reason ?? 'generation_failed';
                        this.requiredActions = response.required_actions ?? [];
                        this.errorMessage = response.message || $localize`Napaka pri generiranju QR kode.`;
                    }
                },
                error: (error) => {
                    this.isLoading = false;
                    this.errorReason = error?.error?.reason ?? 'generation_failed';
                    this.requiredActions = error?.error?.required_actions ?? [];
                    this.errorMessage = error?.error?.message || $localize`Napaka pri generiranju QR kode. Poskusite znova.`;
                }
            });
    }

    close(): void {
        this.dialogRef.close();
    }
}
